export type Revendeur = {
  name: string;
  prix: number;
  url: string;
};

export type Product = {
  slug: string;
  sku: string;
  name: string;
  category: string;
  short: string;
  description: string;
  specs: Record<string, string>;
  images: Array<string>;
  revendeurs: Revendeur[];
  ficheTechnique: string;
};

export const products = [
  {
    slug: "armoire-fusils-6-armes",
    sku: "Tresorsafe6",
    name: "Armoire à fusils — 6 armes",
    category: "Armoires à fusils",
    short: "Armoire sécurisée pour 6 armes, ancrage renforcé, serrure à clés.",
    description:
      "Construction acier, parois renforcées. Conçue pour un stockage sûr de 6 armes longues. Pré-perçages pour ancrage mural et au sol.",
    specs: {
      Capacité: "6 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 350 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 346 x 220 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 440 x 170 mm",
      Poids: "45 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles face.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-bas.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-coffre-interieur.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-lateral.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-situation.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-usps.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-with-riffles.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 241.87,
        url: "https://1001coffres.com/armoire-1-9-fusils/8218-armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS6/fiche technique 6 fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-8-armes",
    sku: "Tresorsafe8",
    name: "Armoire à fusils — 8 armes",
    category: "Armoires à fusils",
    short:
      "Version 8 fusils avec mousse de protection, compartiments accessoires, range-documents sur la porte et ancrage sur serrure multi-points.",
    description:
      "Idéale pour collections moyennes. Charnières dissimulées et renforts anti-arrachement.",
    specs: {
      Capacité: "8 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 450 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 446 x 220 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 440 x 170 mm",
      Poids: "55 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-face.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-coffre-interieur.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-ouverte-remplie.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-ouverte.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-situation.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-USPs.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 272.65,
        url: "https://1001coffres.com/armoire-1-9-fusils/8219-armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS8/fiche technique 8 fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-12-armes",
    sku: "Tresorsafe12",
    name: "Armoire à fusils — 12 armes",
    category: "Armoires à fusils",
    short:
      "Grande capacité 12 armes, parois multi-couches et points d’ancrage renforcés.",
    description:
      "Pour les besoins exigeants. Séparateurs intérieurs, mousse de protection, coffre intérieur pour munitions, range-documents sur la porte.",
    specs: {
      Capacité: "12 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 700 x 330 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 696 x 250 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 240 x 160 mm",
      Poids: "80 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-fermée.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-ouverte-complete.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-ouverte.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-USPs.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 423.2,
        url: "https://1001coffres.com/armoire-10-fusils/8220-armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS12/Tresor Safe Tresorsafe12 fusils.pdf",
  },
];
